const DEFAULT_PRIORITY = 5;
export function getModalByName(name) {
    // @ts-expect-error Check for typing
    const modal = document.querySelector(`ux-modal[name="${name}"]`);
    return modal;
}
export function getPriority(name) {
    const modal = getModalByName(name);
    // eslint-disable-next-line @stencil-community/strict-boolean-conditions
    if (!modal?.priority || isNaN(modal.priority)) {
        return DEFAULT_PRIORITY;
    }
    return modal.priority;
}
//# sourceMappingURL=modal-utils.js.map
